exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .loading-overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10000;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  background-color: rgba(255, 255, 255, 0.6);\n}\n\n", ""]);

// exports
